<template>
	<div>
		<headdv  ></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<headdv2  @SearchFun="SearchFun"  :headData="headData"></headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%">
						<el-table-column prop="ua_id" label="账户ID" ></el-table-column>
						<el-table-column prop="u_id" label="用户ID" ></el-table-column>
						<el-table-column prop="ua_balance" label="账户人民币余额" ></el-table-column>
						<el-table-column prop="ua_gold" label="账户金币余额" ></el-table-column>
						<el-table-column prop="u_name" label="用户名"></el-table-column>
					</el-table>
				</div>
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
	</div>
</template>
<script>
export default {
	data() {
		return {
			headData:{
				title:'后台账号列表',
				add:false,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			searchVal:'',
			//分组id
			accountList: [], //列表数据
		};
	},
	created() {
		this.getclasslist();
	},
	methods: {
		//获取列表数据--用户列表
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&key=${this.searchVal}`;
			this.https(this.apiList.getUserAccountList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
               this.accountList = response.data.data.rows; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
				}
			});
		},
		
		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
				this.searchVal = data
				this.getclasslist();
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1
        condition1(){
			  this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选3
        condition3(){
            console.log('condition3')
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
        },
        //分页
			//pageSize 改变时会触发    每页条数
			handleSizeChange(val) {
				console.log(val)
				this.pageData.pagesize = val 
				this.getclasslist();
			},
			//currentPage 改变时会触发     当前页
			handleCurrentChange(val) {
				console.log(val)
				this.pageData.pageindex = val
				this.getclasslist();
			},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
	},
};
</script>
<style lang="scss" scoped>

// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>